module.exports = __webpack_public_path__ + "static/media/close_dark.570fa9f8.png";